import type { Core } from "../../..";
import type {
	Fields,
	MenuItemsSchema,
	SchemaTypeWithComponentProp,
} from "../misc/types";
import type { Parser } from "../parser";

import { getTypeFromField } from "../misc/utils";

export class MenuItemsParser implements Parser {
	private getMenuItemsProps(
		fields: Array<Fields> | undefined,
		autotypesConfig: Core.Config["autotypes"],
	) {
		if (!fields) {
			return "";
		}

		return fields
			.map((field) =>
				getTypeFromField(field, "object", {
					hasDistributorData: false,
					getStaticData: false,
					moduleSchemas: [],
					schema: {} as SchemaTypeWithComponentProp,
					allSchemas: {},
					autotypesConfig,
				}),
			)
			.join("");
	}

	parse(schema: MenuItemsSchema, config: Core.Config): string {
		const linkFields = schema?.link?.fields as any;
		const groupFields = schema?.group?.fields as any;
		const menuItemsLinksProps = this.getMenuItemsProps(
			linkFields,
			config.autotypes,
		);
		const menuItemsGroupProps = this.getMenuItemsProps(
			groupFields,
			config.autotypes,
		);

		return `
		export interface InstanceMenuItems {
			link:{
				${menuItemsLinksProps}
				config?: {
					headerStyle?: string;
					footerStyle?: string;
					type?: "link";
				};
			};
			group: {
				url?: null;
				${menuItemsGroupProps}
				config?: {
					headerStyle?: string;
					footerStyle?: string;
					type?: "group";
				};
			};
		}
		export type LinkMenuElement = Fields.BaseLinkElement<InstanceMenuItems> & InstanceMenuItems["link"];
		export type GroupMenuElement = Fields.BaseLinkElement<InstanceMenuItems> & InstanceMenuItems["group"];
		export type MenuElement = LinkMenuElement | GroupMenuElement;
		export type Menu = Fields.Menu<InstanceMenuItems>;
	`;
	}
}
